import React from 'react';
import './ProctorShowcase.css';

const ProctorShowcase = () => {
  return (
    <section className="proctor-showcase">
      <div className="ps-bg" />

      <div className="ps-container">
        <div className="ps-header">
          <span className="ps-eyebrow">Proven track record</span>
          <h2 className="ps-title">
            Hundreds of <span className="ps-accent">Successful Exams</span>
          </h2>
          <p className="ps-subtitle">
            We reliably beat the most secure proctoring and lockdown systems.
          </p>
        </div>

        <div className="ps-stack">
          {/* Featured banner — Respondus LockDown Browser */}
          <article className="ps-banner">
            <div className="ps-logo ps-logo--lg">
              <img
                src="/images/comps/Respondus.webp"
                alt="Respondus LockDown Browser"
                loading="lazy"
              />
            </div>

            <div className="ps-banner-text">
              <h3 className="ps-name">LockDown Browser</h3>
              <p className="ps-desc">
                The strictest lockdown browser out there — bypassed consistently and fully undetected.
              </p>
              <p className="ps-proof">
                <span className="ps-check">✔</span> Bypassed <span className="ps-dot">·</span> 0 detections <span className="ps-dot">·</span> Webcam + screen
              </p>
            </div>
          </article>

          {/* Two below */}
          <div className="ps-row">
            <article className="ps-card">
              <div className="ps-logo ps-logo--seb">
                <img
                  src="/images/comps/SafeExamBrowser.webp"
                  alt="Safe Exam Browser"
                  loading="lazy"
                />
              </div>
              <h3 className="ps-name ps-name--sm">Safe Exam Browser</h3>
              <p className="ps-desc ps-desc--sm">Kiosk-mode lockdown browser — fully bypassed.</p>
              <p className="ps-proof">
                <span className="ps-check">✔</span> Bypassed <span className="ps-dot">·</span> 0 detections
              </p>
            </article>

            <article className="ps-card">
              <div className="ps-logo ps-logo--cluster">
                <img src="/images/comps/Digi_Exam.webp" alt="DigiExam" loading="lazy" />
                <img src="/images/comps/Proctorio.webp" alt="Proctorio" loading="lazy" />
                <img src="/images/comps/Honorlock.webp" alt="Honorlock" loading="lazy" />
                <img src="/images/comps/Examity.webp" alt="Examity" loading="lazy" />
                <img src="/images/comps/Examplify.webp" alt="Examplify" loading="lazy" />
                <img src="/images/comps/Proctortrack.webp" alt="ProctorTrack" loading="lazy" />
              </div>
              <h3 className="ps-name ps-name--sm">
                &amp; <span className="ps-num">22</span> Others
              </h3>
              <p className="ps-desc ps-desc--sm">Every major proctoring and assessment platform.</p>
              <p className="ps-proof">
                <span className="ps-check">✔</span> Bypassed <span className="ps-dot">·</span> Undetected
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProctorShowcase;
